import { render, staticRenderFns } from "./NotCertified.vue?vue&type=template&id=f1046bbc&scoped=true&"
import script from "./NotCertified.vue?vue&type=script&lang=js&"
export * from "./NotCertified.vue?vue&type=script&lang=js&"
import style0 from "./NotCertified.vue?vue&type=style&index=0&id=f1046bbc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1046bbc",
  null
  
)

export default component.exports